import CmsHomepageSectionTableRow from 'domains/cms-homepage-section/table/cms-homepage-section-table-row'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'

const propTypes = {
  tableProps : PropTypes.object,
  sections   : PropTypes.array,
  onClickRow : PropTypes.func
}

const defaultProps = {
  onClickRow: () => { }
}

/**
 * Table to display specific ::Cms::Homepage::Section columns
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} sections - array of Cms::Homepage::Section
 * @param {Function} onClickRow - function handler for on Click Row
 */
const CmsHomepageSectionTable = ({
  sections,
  onClickRow,
  ...tableProp
}) => (
  <Table
    { ...tableProp }
  >
    <thead>
      <tr>
        <th scope="col">{ 'Order' }</th>
        <th scope="col">{ 'Image' }</th>
        <th scope="col">{ 'Name' }</th>
        <th scope="col">{ 'Is Active' }</th>
      </tr>
    </thead>
    <tbody>
      { sections.map((section, index) => (
        <CmsHomepageSectionTableRow
          key={ `${section.name}-${index}` }
          section={ section }
          onClickRow={ onClickRow }
        />
      )) }
    </tbody>
  </Table>
)


CmsHomepageSectionTable.propTypes    = propTypes
CmsHomepageSectionTable.defaultProps = defaultProps

export default CmsHomepageSectionTable